<template>
  <div class="chooseEnt" v-if="showEnt">
    <div class="chooseEntBox">
      <div class="form-group white">
        <label class="van-col--8">
          企业名称：
          <span class="imp">*</span>
        </label>
        <div :class="elect? 'van-col--12' : 'van-col--14'">
          <input v-model="pageEntName" @click="getEnt" :readonly="intRead" :placeholder="intRead?'请选择企业':'请输入企业'" />
        </div>
        <button class="electClass" v-show="elect" @click="intReadClick">{{intRead ? '输入' : '选择'}}</button>
      </div>
    </div>
    <!-- 选择企业 -->
    <van-popup v-model="showEntPop" position="right" class="pageBox">
      <div class="page">
        <div class="top">
          <div class="header">
            <div class="left" @click="showEntPop = false"></div>
            <h1>选择企业</h1>
          </div>
          <van-search v-model="searchEntName" placeholder="请输入企业名称" show-action shape="round" @search="onEntSearch">
            <div slot="action" class="searchBtn" @click="onEntSearch">搜索</div>
          </van-search>
          <div class="totalNum">总数：{{ entTotal }} 个</div>
        </div>
        <div class="list">
          <p class="noDataText" v-if="entList.length === 0 && entFinished">
            暂无数据
          </p>
          <van-list v-model="entLoading" :finished="entFinished" @load="getPageEnterprise" :immediate-check="true">
            <p v-for="(item, index) in entList" :key="index" class="item" @click="chooseEnt(item)">
              <span class="span1">{{ index + 1 }}.</span>
              <span class="span2">{{ item.entName }}</span>
            </p>
          </van-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { pageEnterprise } from '@/api/dictionary'

export default {
  name: 'chooseEnt',
  props: {
    showEntId: {
      type: String,
      default() {
        return ''
      },
    },
    elect: {
      type: Boolean,
      default: false
    },
    showEntName: {
      type: String,
      default() {
        return ''
      },
    },
    patrolObjType: {
      type: Number,
      default() {
        return 0
      },
    },
    showEnt: {
      type: Boolean,
      default() {
        return this.$checkUserType()
      },
    },
  },
  data() {
    return {
      areaCodeCity: this.$store.state.areaCodeCity || '',
      areaCodeDistrict: this.$store.state.areaCodeDistrict || '',
      areaCodeSubdistrict: this.$store.state.areaCodeSubdistrict || '',
      entList: [],
      pageEntName: '',
      pageEntId: '',
      entPageNum: 1,
      entPageSize: 20,
      entTotal: 0,
      entFinished: false,
      entLoading: false,
      showEntPop: false,
      searchEntName: '',
      industryId: '', // 0种植业 1畜禽养殖业
      industryList: [
        { industryName: '种植业', industryIds: '0' },
        { industryName: '畜牧业', industryIds: '1' },
        { industryName: '渔业', industryIds: '2' },
        { industryName: '其它', industryIds: '9' }
      ],
      intRead: true //企业名称的输入方式
    }
  },
  watch: {
    showEntId(newValue) {
      this.pageEntId = newValue
    },
    showEntName(newValue) {
      this.pageEntName = newValue
    },
    patrolObjType(newValue) {
      if (newValue === 1) {
        this.industryId = '0'
      } else if (newValue === 3) {
        this.industryId = '1'
      } else if (newValue === 4) {
        this.industryId = '2'
      } else {
        this.industryId = ''
      }
      this.entList = []
      this.getPageEnterprise()
    },
  },
  created() {
    // 用户类型
    // this.checkUserType();
  },
  mounted() {
    this.pageEntId = this.showEntId
    this.pageEntName = this.showEntName
  },
  methods: {
    intReadClick() {
      let bool = this.intRead;
      this.pageEntName = ''; this.pageEntId = '';
      if (bool) { this.intRead = false; } else { this.intRead = true; };
      this.$emit('electClick', this.intRead)
    },
    onEntSearch() {  // 搜索企业名称
      this.entPageNum = 1
      this.entList = []
      if (this.entFinished) {
        this.entFinished = false
      } else {
        this.getPageEnterprise()
      }
    },
    chooseEnt(obj) {  // 选择企业名称
      this.pageEntName = obj.entName
      this.pageEntId = obj.entId
      this.showEntPop = false;
      this.$emit('getEntId', obj)
    },
    getPageEnterprise() { // 获取企业
      pageEnterprise({
        areaCodeCity: this.areaCodeCity || '',
        areaCodeDistrict: this.areaCodeDistrict || '',
        areaCodeSubdistrict: this.areaCodeSubdistrict || '',
        villageCode: '',
        industryId: this.industryId,
        registeredNumber: '',
        contactPhone: '',
        entName: this.searchEntName,
        pageNum: this.entPageNum++,
        pageSize: this.entPageSize,
      }).then(res => {
        if (res.state === 'Y') {
          let rows = res.rows
          this.entTotal = parseInt(res.total)
          if (rows.length === 0) {
            this.entLoading = false
            this.entFinished = true
            if (this.entPageNum === 2) {
              this.entList = []
            }
            return
          }
          this.entList.push(...res.rows)
          this.entLoading = false
          if (parseInt(res.total) === this.entList.length) {
            this.entFinished = true
          }
        } else {
          this.entLoading = false
          this.entFinished = true
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.entLoading = false
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    getEnt() { // 打开选择企业
      if (this.intRead) {
        this.industryId = this.patrolObjType ? (this.patrolObjType === 1 ? '0' : '1') : '';
        this.showEntPop = true;
      }
    },
    // checkUserType () { // 获取用户类型
    //   if (!this.$checkUserType()) { // 企业端 和 游客
    //     this.showEnt = false;
    //   } else { // 管理员 和 监管用户
    //     this.showEnt = true;
    //   }
    // }
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.chooseEnt {
  width: 100%;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}
.electClass{
  height: 70%;
    line-height: initial;
    margin-top: 8px;
    border: 0px;
    background-color: #49D68B;
    color: #fff;
    border-radius: 5px;
}
</style>
